import React, { useEffect, useState } from 'react';
import ConfirmModal from '../../Common/ConfirmModal';

export default function MakePaymentButton({ paypayment, text = 'Make Payment', selectedMethod = 'card', orderdetails }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [data, setData] = useState({});

  const baseUrl = window.location.origin;
  const publicUrl = process.env.PUBLIC_URL || '';

  // ===============================
  // RESET
  // ===============================
  const resetPayment = () => {
    setModalOpen(false);
    setData({});
    setIsLoading(false);

    const container = document.getElementById('hyperpay-widget-container');
    if (container) container.innerHTML = '';

    delete window.wpwlOptions;
  };

  // ===============================
  // API CALL
  // ===============================
  const handlePayment = async () => {
    resetPayment();

    try {
      setIsLoading(true);
      
      console.log("Frontend Amount being submitted:", orderdetails?.post_price);

      const response = await paypayment(selectedMethod);
      const result = response?.data?.response?.result;

      console.log("Server Authorized Amount for Gateway:", result?.payable_amount);

      // FULL WALLET PAYMENT CHECK
      if (result?.payable_amount === 0) {
        window.location.href = `${baseUrl}${publicUrl}/${localStorage.getItem('laung') || 'en'}/account/paymentsuccessful/${result.transaction_id}?wallet=${selectedMethod === 'wallet' ? 1 : 0}`;
        return;
      }

      if (!result?.request_id || !result?.transaction_id) {
        console.error('Invalid HyperPay response', response);
        return;
      }

      setData(result);
      setModalOpen(true);
    } catch (error) {
      console.error('Payment error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // ===============================
  // LOAD HYPERPAY
  // ===============================
  useEffect(() => {
    if (!modalOpen || !data?.request_id) return;

    const container = document.getElementById('hyperpay-widget-container');
    if (!container) return;

    container.innerHTML = '';

    // Configure options based on selected payment brand
    if (selectedMethod === 'applepay') {
      window.wpwlOptions = {
        style: 'plain', // Use plain style so Apple Pay renders its native button layout cleanly
        locale: 'en',
        paymentTarget: '_top',
        applePay: {
          displayName: "Your Store Name",
          total: { label: "Your Store Name" }
        }
      };
    } else {
      window.wpwlOptions = {
        style: 'card',
        locale: 'en',
        paymentTarget: '_top',
        registrations: {
          requireCardHolder: true,
        },
        cardHolder: {
          placeholder: 'Card Holder Name',
        },
        onReady: () => {
          const input = document.querySelector('.wpwl-control-cardHolder');
          if (input) {
            input.setAttribute('required', 'true');
            input.setAttribute('minlength', '3');
          }
        },
      };
    }

    const form = document.createElement('form');
    form.className = 'paymentWidgets';
    form.setAttribute('method', 'GET');
    
    // Set brand conditionally
    if (selectedMethod === 'applepay') {
      form.setAttribute('data-brands', 'APPLEPAY');
    } else {
      form.setAttribute('data-brands', 'VISA MASTER MADA');
    }

    form.setAttribute(
      'action',
      `${baseUrl}${publicUrl}/${localStorage.getItem('laung') || 'en'}/account/paymentsuccessful/${data.transaction_id}?wallet=${selectedMethod === 'wallet' ? 1 : 0}`
    );

    const script = document.createElement('script');
    script.src = `https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=${data.request_id}`;
    script.async = true;

    container.appendChild(form);
    container.appendChild(script);

    return () => {
      container.innerHTML = '';
      delete window.wpwlOptions;
    };
  }, [modalOpen, data, baseUrl, publicUrl, selectedMethod]);

  // ===============================
  // UI
  // ===============================
  return (
    <>
      <br></br>
      <button onClick={handlePayment} disabled={isLoading} className="buttons background-button w-100">
        {isLoading ? 'Processing...' : text}
      </button>

      {modalOpen && data?.request_id && (
        <div
          key={data.request_id}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.9)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: '#fff',
              width: '100%',
              height: '100%',
              padding: 20,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <h2>{selectedMethod === 'applepay' ? 'Authorize Apple Pay' : 'Enter Card Details'}</h2>

            <div
              id="hyperpay-widget-container"
              style={{
                width: '100%',
                maxWidth: 500,
                flex: 1,
              }}
            />

            <button
              onClick={() => { setConfirmModal(!confirmModal) }}
              style={{
                marginTop: 20,
                padding: '10px',
                background: '#f44336',
                color: '#fff',
                border: 'none',
                width: 200,
                cursor: 'pointer',
              }}
            >
              Cancel Payment
            </button>
          </div>
        </div>
      )}

      <ConfirmModal
        isOpen={confirmModal}
        toggle={() => setConfirmModal(false)}
        title=""
        message="Do you want to Cancel Payment?"
        onConfirm={resetPayment}
      />
    </>
  );
}